import { ContentSummary, ContentSummaryVariant } from "common/components/ContentSummary"
import { imageSizes } from "common/lib/imageSizes"
import { MostReadProps } from "./MostRead"
import clsx from "classnames"

/**
 * The most read component is rendered as a ordered list of content summaries
 * in a 2 column grid for larger devices and 1 column for smaller devices.
 */
export const MostReadView = ({ contentSummaries }: MostReadProps) => {
  "use memo"

  if (!contentSummaries || contentSummaries.length === 0) {
    return null
  }

  const numRows = Math.ceil(contentSummaries.length / 2)
  return (
    <section className="mt-12 mb-4">
      {/*
      Safari has a bug/feature where voice over won't properly read the list items.
      This happens if the list style is none which is currently required for us since we homebrew our own numbering system/order.
      To avoid this "functionality", we need to give the ol role=list even though it's meant to be redundant, it fixes the behaviour
      */}
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ol
        role="list"
        className={clsx("grid list-none gap-4 sm:gap-6 md:grid-flow-col", {
          "md:grid-rows-[repeat(1,auto)]": numRows === 1,
          "md:grid-rows-[repeat(2,auto)]": numRows === 2,
          "md:grid-rows-[repeat(3,auto)]": numRows === 3,
        })}
      >
        {contentSummaries.map((contentSummary, index) => (
          <li key={index} className="flex justify-between gap-2 border-t border-gray-200 pt-4">
            <div className="font-serif text-2xl break-normal italic">{index + 1}.</div>

            <ContentSummary
              {...contentSummary}
              className="most-read-block"
              variant={ContentSummaryVariant.BaseWide}
              imageSizes={imageSizes({ lg: 0.125, sm: 0.25 })}
            />
          </li>
        ))}
      </ol>
    </section>
  )
}
